async function messageExtension(messageName, messagePayload) {
	return new Promise(resolve => {
		// eslint-disable-next-line no-undef
		const chromeRuntime = window.chrome?.runtime
		if (!chromeRuntime) {
			// this only works in Chrome, Edge, Brave, and Opera; for all others, we "fail" silently
			resolve()
		}

		try {
			chromeRuntime.sendMessage(
				import.meta.env.VUE_APP_EXTENSION_ID,
				{name: messageName, ...messagePayload},
				function (response) {
					if (chromeRuntime.lastError) return resolve()
					resolve(response)
				}
			)
		} catch (error) {
			// all failure is silent, because we can't expect this mechanism to work in all environments (e.g. Safari)
			resolve()
		}
	})
}

export default messageExtension
